import { useBreadcrumb } from "components/Breadcrumb/context";
import type { FC, HTMLAttributes } from "react";
import { Link } from "react-router-dom";

export type Breadcrumb = {
  label: string;
  to?: string;
};

export type BreadcrumbProps = HTMLAttributes<HTMLElement>;

export const BreadcrumbUI: FC<BreadcrumbProps> = () => {
  const context = useBreadcrumb();
  return (
    <div className="text-sm breadcrumbs">
      <ul>
        {context.breadcrumbItems.map((v, index) => {
          const isLast = index === context.breadcrumbItems.length - 1;
          return (
            <li key={`${v.label}-${index}`}>
              {v.to && !isLast ? (
                <Link
                  to={v.to}
                  className="text-primary hover:text-primary/80 transition-colors"
                >
                  {v.label}
                </Link>
              ) : (
                <span
                  className={
                    isLast ? "text-gray-700 font-medium" : "text-gray-500"
                  }
                >
                  {v.label}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
